import { Box, useMediaQuery, Tab, Tabs, Typography, Grid, Alert } from "@mui/material";
import * as React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import UserAccountSettings from "./userAccountSettings";
import UserAgreementDocuments from "./userAgreementDocuments";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Settings = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [isFailed, setIsFailed]  = React.useState(false);
  const landlordDetails = useSelector((state) => state.landlordDetails);
  const location = useLocation();
  const showVerificationAlert = location.state?.showVerificationAlert || false;

  // Auto-switch to User Onboarding tab if redirected from login with unverified status
  React.useEffect(() => {
    if (showVerificationAlert && !landlordDetails?.verified_status) {
      setValue(0); // Switch to User Onboarding tab (index 0)
    }
  }, [showVerificationAlert, landlordDetails]);

  React.useEffect(() =>{
    const timer = setTimeout(() => {
      setIsSuccess(false)
      setIsFailed(false)
    }, 3000);
    return () => clearTimeout(timer);
  }, [isSuccess, isFailed]);


  return (
    <Box m="20px">
          <Grid container spacing={2}>
			 <Grid item xs={12}>
              {/* Show alert if verified_status is false */}
              {(!landlordDetails?.verified_status || showVerificationAlert) && (
                <Alert 
                  severity="warning" 
                  sx={{ mb: 3 }}
                  onClose={() => {
                    // Clear the location state to hide alert after closing
                    window.history.replaceState({}, document.title);
                  }}
                >
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                    Account Verification Required
                  </Typography>
                  <Typography>
                    Please upload the necessary documents to verify your account and gain full access to all features. 
                    Complete your onboarding by uploading the required documents in the "User Onboarding" tab below.
                  </Typography>
                </Alert>
              )}
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs fullWidth value={value} onChange={handleChange} aria-label="basic tabs example" centered variant="scrollable" allowScrollButtonsMobile>
                  <Tab label="User Onboarding" {...a11yProps(0)} />  
                  <Tab label="User Account Settings" {...a11yProps(1)} />      
                  <Tab label="Deleted Properties" {...a11yProps(2)} />               
                </Tabs>
              </Box>
              <Box>
                <TabPanel value={value} index={1}><UserAccountSettings /></TabPanel>
                <TabPanel value={value} index={0}><UserAgreementDocuments /></TabPanel>
              </Box>
           </Grid>
          </Grid>
    </Box>
  );
};

export default Settings;